class MaskTechSpecs {
  constructor(section) {
    this.section = section;
    this.callouts = section.querySelectorAll('.masktech__callout');
    this.init();
  }

  init() {
    this.observeCallouts();
  }

  observeCallouts() {
    if (!this.callouts.length) return;

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        console.log('Intersection Observer triggered for:', entry.target, 'isIntersecting:', entry.isIntersecting);
        if (entry.isIntersecting) {
          const rule = entry.target.querySelector('.masktech__rule');
          console.log('Found rule:', rule);
          if (rule) {
            rule.classList.add('masktech__rule--animate');
            console.log('Added animation class to rule');
          }
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    this.callouts.forEach(callout => {
      observer.observe(callout);
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  const maskTechSection = document.querySelector('#mask-tech-specs');
  if (maskTechSection) {
    new MaskTechSpecs(maskTechSection);
  }
});
